import React from 'react';
import {Link} from 'react-router-dom';
import './Navigation.css';
import Button from '../Button';

const Navigation = ({btnText}) => {
    return (
        <div className="wtm-navbar">
            <div className="container">
                <div className="navbar-header">
                    <Link className="navbar-brand" to="/">
                        <img src="/img/logo/horiz_rgb.png" alt=""/>
                    </Link>
                </div>
                <ul className="nav navbar-nav">
                    <li className="nav-item hide-mobile">
                        <Link to="/timeTable" className="nav-link">
                            시간표
                        </Link>
                    </li>
                    <li className="nav-item hide-mobile">
                        <Link to="/CodeOfConduct" className="nav-link">
                            행동강령
                        </Link>
                    </li>
                    {/*<li className="nav-item hide-mobile">*/}
                    {/*<Link to="/activity" className="nav-link">*/}
                    {/*Activity*/}
                    {/*</Link>*/}
                    {/*</li>*/}
                    <li className="nav-item">
                        <Button btnText="피드백 남기기" extraClassName="btn-main-event btn-sm" absoluteUrl={"https://forms.gle/4c2U832qq7XKN3237"}/>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Navigation;
